import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "./Sistema.css"
import imagenSistema from "../images/imagen-sistema.png"
import { Button } from 'flowbite-react';
import { Link } from "react-scroll";

const buttonStyleAzul = {
    backgroundColor: '#111125',
    color: 'white',
    borderRadius: '28px',
    fontFamily: 'Inter, sans-serif', 
    fontSize: '24px',
    fontWeight: 'semi-bold',
  };

function Sistema() {
  return (
    <Container className='contenedor-sobrenosotros'>
        <Row>
            <Col className="d-flex align-items-center col-md-5 d-none d-md-block">
                <div className='contenedor-imagen'>
                    <img src={imagenSistema} className="imagenInicio d-flex align-items-center" alt="logo" />
                </div>
            </Col>
            {/* <Col className='col-lg-1' ></Col> */}
            <Col className='col-md-7 col-sm-12'>
                {/* <h5 className='pretitulo'>Lorem Ipsum Dolor</h5> */}
                <h4 className='titulo-blanco'>Te creamos un <span className='titulo-azul'>sistema de captacion de clientes rentables</span></h4>
                <p className='parrafoSistema'>Tu empresa tiene que implementar estos dos tipos de sistemas:
                                        <br/>1) Captación de clientes y Crecimiento Orgánico.
                                        <br/>2) Captación de clientes y Crecimiento con Ads.
                </p>
                <div className='contenedor-boton gap-2'>
                    <Link  to='calendly' smooth={false} offset={-70} duration={700} color="text">
                        <Button className='mt-10 p-0' size="lg" style={buttonStyleAzul}>Agendemos una llamada</Button>
                    </Link>
                </div>
            </Col>
            
        </Row>
    </Container>
  )
}

export default Sistema
